import Helper, { DateFormat } from "@/services/Helper";
import { TaskModel } from "./TaskModel";

class TaskClockModel
{
    constructor (obj?: TaskClockModel)
    {
        if (obj)
        {
            Object.assign(this, obj);
        }
    }

    public Task?: TaskModel | null;

    public PausedList?: Array<ClockPauseModel> | null;

    public Id?: string | null;
    
    public TaskId?: number | null
    
    public RequestId?: number | null;
    
    private _Scheduled?: string | null;

    public get Scheduled (): string | null
    {
        return Helper.dateToInput(this.ScheduledAsDate, DateFormat.Date) || null;
    }

    public set Scheduled (val: string | null)
    {
        this._Scheduled = val || null;
    }

    public get ScheduledAsDate (): Date | null
    {
        if (this._Scheduled)
        {
            return Helper.dateFromString(this._Scheduled) || null;
        }

        return null;
    }
    
    public Rate?: number | null;
    
    private _Start?: string | null;

    public get Start (): string | null
    {
        return Helper.dateToInput(this.StartAsDate, DateFormat.DateTime) || null;
    }

    public set Start (val: string | null)
    {
        this._Start = val || null;
    }

    public get StartAsDate (): Date | null
    {
        if (this._Start)
        {
            return Helper.dateFromString(this._Start) || null;
        }

        return null;
    }
    
    private _Stop?: string | null;

    public get Stop (): string | null
    {
        return Helper.dateToInput(this.StopAsDate, DateFormat.DateTime) || null;
    }

    public set Stop (val: string | null)
    {
        this._Stop = val || null;
    }

    public get StopAsDate (): Date | null
    {
        if (this._Stop)
        {
            return Helper.dateFromString(this._Stop) || null;
        }

        return null;
    }
    
    private _Paused?: string | null;
    
    public TimePaused?: number | null;
    
    public TimeTotal?: number | null;
    
    public Options?: string | null;
    
    public Status?: number | null;
    
    private _Modified?: string | null;

    public get Modified (): string | null
    {
        return Helper.dateToInput(this.ModifiedAsDate, DateFormat.DateTime) || null;
    }

    public set Modified (val: string | null)
    {
        this._Modified = val || null;
    }

    public get ModifiedAsDate (): Date | null
    {
        if (this._Modified)
        {
            return Helper.dateFromString(this._Modified) || null;
        }

        return null;
    }
    
    private _Created?: string | null;

    public get Created (): string | null
    {
        return Helper.dateToInput(this.CreatedAsDate, DateFormat.DateTime) || null;
    }

    public set Created (val: string | null)
    {
        this._Created = val || null;
    }

    public get CreatedAsDate (): Date | null
    {
        if (this._Created)
        {
            return Helper.dateFromString(this._Created) || null;
        }

        return null;
    }
}

class ClockModel extends TaskClockModel
{
    // ... alias 
}

class ClockPauseModel
{
    
    constructor(obj?: ClockPauseModel)
    {
        if (obj)
        {
            Object.assign(this, obj);
        }
    }

    public Id?: string | null;
    
    public ClockId?: string | null;
    
    private _Paused?: string | null;

    public get Paused (): string | null
    {
        return Helper.dateToInput(this.PausedAsDate, DateFormat.DateTime) || null;
    }

    public set Paused (val: string | null)
    {
        this._Paused = val || null;
    }

    public get PausedAsDate (): Date | null
    {
        if (this._Paused)
        {
            return Helper.dateFromString(this._Paused) || null;
        }

        return null;
    }
    
    private _Resumed?: string | null;

    public get Resumed (): string | null
    {
        return Helper.dateToInput(this.ResumedAsDate, DateFormat.DateTime) || null;
    }

    public set Resumed (val: string | null)
    {
        this._Resumed = val || null;
    }

    public get ResumedAsDate (): Date | null
    {
        if (this._Resumed)
        {
            return Helper.dateFromString(this._Resumed) || null;
        }

        return null;
    }
    
    public Diff?: number;
    
    private _Modified?: string | null;

    public get Modified (): string | null 
    { 
        return Helper.dateToInput(this.ModifiedAsDate, DateFormat.DateTime) || null; 
    }

    public set Modified (val: string | null)
    {
        this._Modified = val || null;
    }

    public get ModifiedAsDate (): Date | null
    {
        if (this._Modified)
        {
            return Helper.dateFromString(this._Modified) || null;
        }

        return null;
    }
    
    private _Created?: string | null;

    public get Created (): string | null
    {
        return Helper.dateToInput(this.CreatedAsDate, DateFormat.DateTime) || null;
    }

    public set Created (val: string | null)
    {
        this._Created = val || null;
    }

    public get CreatedAsDate (): Date | null
    {
        if (this._Created)
        {
            return Helper.dateFromString(this._Created) || null;
        }

        return null;
    }   
}

export { TaskClockModel, ClockModel, ClockPauseModel }